/* ==========================================================================
   Breaker Outlet header - option A

   In the stock theme the menu sits in its own row below the search, and the
   search overlay covers it, so opening a menu always went through the
   overlay and closed the search (see handleClickOutside in search.js).

   In draft A the menu sits in the white row beside the search, above the
   overlay, so a mega menu can open while the predictive-search panel is
   still open underneath it. Close the search whenever a menu in the header
   navigation opens. The menus are <details is="details-mega" trigger="hover">,
   so watching for the "open" attribute covers both hover and click.
   ========================================================================== */
(() => {
  const start = () => {
    const nav = document.querySelector('.bo-header__nav');
    if (!nav) return;

    const closeSearch = () => {
      document.querySelectorAll('predictive-search.predictive-search-open').forEach((search) => {
        if (typeof search.toggleSearchState === 'function') {
          search.toggleSearchState(false);
        } else {
          search.classList.remove('predictive-search-open');
          document.body.classList.remove('search-open');
        }
        /* Without this the field keeps focus, and the panel springs back the
           moment the shopper types again without clicking the field. */
        search.querySelector('input[type="search"]')?.blur();
      });
    };

    new MutationObserver((records) => {
      for (const record of records) {
        if (record.target.hasAttribute('open')) {
          closeSearch();
          return;
        }
      }
    }).observe(nav, { subtree: true, attributes: true, attributeFilter: ['open'] });
  };

  /* ----------------------------------------------------------------------
     The strip's messages stop rotating once the header has hidden and come
     back. Swiper pauses autoplay at the start of every slide change and only
     resumes when the slide wrapper fires transitionend; while the strip is
     translated off-screen by the collapse-on-scroll rules that event never
     arrives, so autoplay stays paused with running still true.

     waitForTransition: false makes Swiper resume straight away instead of
     waiting for an event that may never come. The interval is the safety net
     for any other path that leaves it paused - for instance a mouseenter with
     no matching mouseleave when the strip slides out from under the pointer.
     ---------------------------------------------------------------------- */
  const keepAnnouncementRotating = () => {
    const bar = document.querySelector('announcement-bar');
    const swiper = bar && bar.swiper;
    if (!swiper || !swiper.autoplay || !swiper.params || !swiper.params.autoplay) return false;

    swiper.params.autoplay.waitForTransition = false;

    const unpause = () => {
      if (document.hidden || bar.matches(':hover')) return;
      if (swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
      }
    };

    unpause();
    setInterval(unpause, 2000);
    return true;
  };

  /* The slider is built on first interaction, so wait for it to appear. */
  const waitForAnnouncement = () => {
    if (keepAnnouncementRotating()) return;
    let tries = 0;
    const timer = setInterval(() => {
      if (keepAnnouncementRotating() || ++tries > 60) clearInterval(timer);
    }, 500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
    document.addEventListener('DOMContentLoaded', waitForAnnouncement);
  } else {
    start();
    waitForAnnouncement();
  }
})();
